var layoutStyles = {"column":"modal__column_1gbm3","gap-16":"modal__gap-16_1gbm3","gap-24":"modal__gap-24_1gbm3","gap-32":"modal__gap-32_1gbm3","start":"modal__start_1gbm3","center":"modal__center_1gbm3","space-between":"modal__space-between_1gbm3"};
require('./components/footer/layout.css');

export { layoutStyles as l };
